import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PageNames } from 'src/app/configs/page-names.enum';
import { AppConfigService } from 'src/app/core/services/config.service';
import { TranslationModule } from 'src/app/i18n';
import { ShareModule } from 'src/app/shared/share.module';
import { PagesSharedModule } from '../../shared/pages-shared.module';
import { CommonModule } from '@angular/common';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
    selector: 'app-panel-documentations',
    templateUrl: './panel-documentations.component.html',
    imports: [
        BaseIndexModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
    ]
})
export class PanelDocumentationsComponent {
  //#region Properties

  pageName = PageNames.panelDocumentations;
  pageVocabs = 'pages.panelDocumentations.';

  smartDocumentations;
  guidanceDocumentations;

  //#endregion

  constructor() {}

  ngOnInit() {
    this.smartDocumentations = AppConfigService.config.smartSmsGuideUrl;
    this.guidanceDocumentations =
      AppConfigService.config.webServiceGuideUrl;
  }
}
